import ShortenerURL from './routes/shortener_url/ShortenerURL.vue';

const ShortenerServiceRoutes = [
  {
    path: 'shortener-url',
    name: 'ShortenerURL',
    component: ShortenerURL,
  }
];

export default ShortenerServiceRoutes;